import { Component as ClockIcon } from 'icons/icon-circle-lime--clock.svg';
import { Component as DumbbellIcon } from 'icons/icon-circle-lime--dumbbell.svg';
import { Component as GlutenFreeIcon } from 'icons/icon-circle-lime--gluten-free.svg';
import { Component as KnifeIcon } from 'icons/icon-circle-lime--knife.svg';
import { Component as LeafIcon } from 'icons/icon-circle-lime--leaf.svg';
import { Component as JumpstartIcon } from 'icons/icon-circle-lime--jumpstart.svg';
import { PlanType } from '../../../models/Plan';

export const PREFERENCES = {
  chefs_choice: {
    value: 'chefs_choice',
    label: 'Chef\'s Choice',
    icon: KnifeIcon,
  },
  chefs_choice_plus: {
    value: 'chefs_choice',
    label: 'Chef\'s Choice',
    icon: KnifeIcon,
  },
  gluten_free: {
    value: 'gluten_free',
    label: 'Gluten-Free',
    icon: GlutenFreeIcon,
  },
  quick_easy: {
    value: 'quick_easy',
    label: 'Less Prep',
    icon: ClockIcon,
  },
  high_protein: {
    value: 'high_protein',
    label: 'High Protein',
    icon: DumbbellIcon,
  },
  high_fiber: {
    value: 'high_fiber',
    label: 'High Fiber',
    icon: LeafIcon,
  },
  four_servings: {
    value: 'four_servings',
    label: 'Chef\'s Choice',
    icon: KnifeIcon,
  },
  prepared_one_serving: {
    value: 'prepared_one_serving',
    label: 'Chef\'s Choice',
    icon: KnifeIcon,
  },
  jumpstart_program: {
    value: 'jumpstart_program',
    label: 'Jumpstart',
    icon: JumpstartIcon,
  },
};

export const PREFERENCES_BY_PLAN_TYPE = {
  [PlanType.MEAL_KIT]: [
    PREFERENCES.chefs_choice_plus,
    PREFERENCES.gluten_free,
    PREFERENCES.quick_easy,
    PREFERENCES.high_protein,
  ],
  [PlanType.PREPARED]: [
    PREFERENCES.prepared_one_serving,
    PREFERENCES.jumpstart_program,
  ],
  [PlanType.PROGRAMS]: [
    PREFERENCES.prepared_one_serving,
    PREFERENCES.jumpstart_program,
  ],
  [PlanType.DIVERSIFIED]: [
    PREFERENCES.chefs_choice,
    PREFERENCES.gluten_free,
    PREFERENCES.high_fiber,
    PREFERENCES.high_protein,
  ],
};

export const DEFAULT_SERVINGS = 2;
export const DEFAULT_MEAL_KIT_EXTRAS = {
  dinner: 1,
  breakfast: 0,
  lunch: 0,
};
export const DEFAULT_PREPARED_EXTRAS = {
  dinner: 2,
  breakfast: 0,
  lunch: 0,
};
export const DEFAULT_NO_EXTRAS = {
  dinner: 0,
  breakfast: 0,
  lunch: 0,
};

export const LIST_ITEMS_BY_PLAN_TYPE = {
  [PlanType.MEAL_KIT]: [
    {
      label: 'Number of servings per meal',
      quantity: {
        chefs_choice: 2,
        quick_easy: 2,
        gluten_free: 2,
        high_protein: 2,
        four_servings: 2,
      },
    },
  ],
  [PlanType.PREPARED]: [
    {
      label: 'Number of servings per meal',
      quantity: {
        prepared_one_serving: 1,
      },
    },
  ],
  [PlanType.PROGRAMS]: [
    {
      label: 'Ready to Eat Breakfasts per Week',
      quantity: {
        jumpstart_program: 4,
      },
    },
    {
      label: 'Ready to Eat Lunches per Week',
      quantity: {
        jumpstart_program: 4,
      },
    },
    {
      label: 'Ready to Eat Dinners per Week',
      quantity: {
        jumpstart_program: 4,
      },
    },
  ],
  [PlanType.DIVERSIFIED]: [
    {
      label: 'Meal Kits per week (2-serving)',
      quantity: {
        chefs_choice_plus: 3,
        chefs_choice: 3,
        high_fiber: 2,
        gluten_free: 2,
        high_protein: 2,
      },
    },
    {
      label: 'Ready-to-Eat Dinners or Lunches per week (1-serving)',
      quantity: {
        chefs_choice_plus: 0,
        chefs_choice: 2,
        high_fiber: 3,
        gluten_free: 3,
        high_protein: 3,
      },
    },
    {
      label: 'Grocery Items per week',
      quantity: {
        chefs_choice_plus: 1,
        chefs_choice: 1,
        high_fiber: 1,
        gluten_free: 1,
        high_protein: 1,
      },
    },
  ],
};
